"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _cccisdReactRouter = require("cccisd-react-router");
var _classnames = _interopRequireDefault(require("classnames"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _capitalize = _interopRequireDefault(require("lodash/capitalize"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _plus = _interopRequireDefault(require("cccisd-icons/plus2"));
var _folderPlus = _interopRequireDefault(require("cccisd-icons/folder-plus"));
var _paperplane = _interopRequireDefault(require("cccisd-icons/paperplane"));
var _cog = _interopRequireDefault(require("cccisd-icons/cog"));
var _warning = _interopRequireDefault(require("cccisd-icons/warning2"));
var _cccisdLaravelNexus = require("cccisd-laravel-nexus");
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _LackingPermissions = _interopRequireDefault(require("../../components/LackingPermissions"));
var _admin = require("../../selectors/admin.js");
var _RespondentForm = _interopRequireDefault(require("./RespondentForm"));
var _RespondentTable = _interopRequireDefault(require("./RespondentTable"));
var _SendMessageNow = _interopRequireDefault(require("./SendMessageNow"));
var _UrlInfo = _interopRequireDefault(require("./UrlInfo"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Appdefs = window.cccisd.appDefs;
var Boilerplate = window.cccisd.boilerplate;
var Fortress = window.cccisd.fortress;
var DeploySettings = /*#__PURE__*/function (_React$Component) {
  function DeploySettings() {
    var _this;
    _classCallCheck(this, DeploySettings);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, DeploySettings, [].concat(args));
    _defineProperty(_this, "state", {
      isLoading: true,
      bulkDef: null
    });
    _defineProperty(_this, "getBulkUploadDef", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var cycle, response, responseBulkDef;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            cycle = _this.props.cycle;
            if (!(cycle.type !== 'known')) {
              _context.n = 1;
              break;
            }
            _this.setState({
              isLoading: false
            });
            return _context.a(2);
          case 1:
            _context.n = 2;
            return _cccisdAxios["default"].get(Boilerplate.route('api.nexus.bulkupload.deploymentRespondentDef') + "?deploymentId=".concat(cycle.deploymentId));
          case 2:
            response = _context.v;
            responseBulkDef = (0, _get2["default"])(response, 'data.data');
            if (responseBulkDef) {
              _this.setState({
                bulkDef: responseBulkDef
              });
            } else {
              console.error('Could not retrieve bulk upload definition');
            }
            _this.setState({
              isLoading: false
            });
          case 3:
            return _context.a(2);
        }
      }, _callee);
    })));
    _defineProperty(_this, "loadTableData", function () {
      _this.rtConnect.table.loadData();
    });
    _defineProperty(_this, "renderAddRespondent", function () {
      var cycle = _this.props.cycle;
      return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: (0, _classnames["default"])('btn', 'btn-primary', _style["default"].btn)
        }, /*#__PURE__*/_react["default"].createElement(_plus["default"], {
          spaceright: true
        }), " Add respondent"),
        title: "Add respondent"
      }, /*#__PURE__*/_react["default"].createElement(_RespondentForm["default"], {
        forCycle: cycle,
        loadData: _this.loadTableData
      }));
    });
    _defineProperty(_this, "renderBulkAdd", function () {
      var _this$state = _this.state,
        bulkDef = _this$state.bulkDef,
        isLoading = _this$state.isLoading;
      var _this$props = _this.props,
        cycle = _this$props.cycle,
        project = _this$props.project;
      var buttonTextSentenceCase = (0, _capitalize["default"])(bulkDef === null || bulkDef === void 0 ? void 0 : bulkDef.triggerText);
      if (isLoading || !bulkDef || Object.keys(bulkDef).length < 1) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement(_cccisdLaravelNexus.BulkUploader, {
        handle: "deploymentRespondent",
        trigger: /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: (0, _classnames["default"])('btn', 'btn-primary', _style["default"].btn)
        }, /*#__PURE__*/_react["default"].createElement(_folderPlus["default"], {
          spaceright: true
        }), " ", buttonTextSentenceCase),
        definition: bulkDef,
        deploymentId: cycle.deploymentId,
        loadData: _this.loadTableData,
        staticColumns: {
          group_id: project.groupId
        }
      });
    });
    _defineProperty(_this, "renderMessaging", function () {
      if (_this.props.restrictionsLevel === 'basic') {
        return null;
      }
      var isQuestTrial = (0, _get2["default"])(Appdefs, 'app.isQuestFreeTrial', false);
      var freeTrialDisabledMessage = 'This feature is not available during trial period.';
      var sendNow = /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: (0, _classnames["default"])('btn', 'btn-info', _style["default"].btn),
        disabled: isQuestTrial
      }, /*#__PURE__*/_react["default"].createElement(_paperplane["default"], {
        spaceright: true
      }), " Send message");
      var messageSettings = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cog["default"], {
        spaceRight: true
      }), "Message settings");
      var messageSettingsButton = /*#__PURE__*/_react["default"].createElement(_cccisdReactRouter.Link, {
        className: "btn btn-info",
        to: "".concat(_this.props.projectLinks.deploy, "/messaging/").concat(_this.props.cycle.deploymentId)
      }, messageSettings);
      if (isQuestTrial) {
        sendNow = /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
          title: freeTrialDisabledMessage
        }, sendNow);
        messageSettingsButton = /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
          title: freeTrialDisabledMessage
        }, /*#__PURE__*/_react["default"].createElement("button", {
          disabled: true,
          className: "btn btn-info",
          type: "button"
        }, messageSettings));
      }
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: sendNow,
        triggerDisabled: isQuestTrial,
        title: "Send Message to Respondents (Right Now)"
      }, /*#__PURE__*/_react["default"].createElement(_SendMessageNow["default"], {
        rtComponent: _this.rtConnect ? _this.rtConnect : null,
        match: _this.props.match
      })), messageSettingsButton);
    });
    _defineProperty(_this, "renderUrlInfo", function () {
      var _cycle$settings, _cycle$settings2;
      var cycle = _this.props.cycle;
      if (cycle !== null && cycle !== void 0 && (_cycle$settings = cycle.settings) !== null && _cycle$settings !== void 0 && _cycle$settings.requireLogin || (cycle === null || cycle === void 0 ? void 0 : cycle.type) === 'anon' || (cycle === null || cycle === void 0 ? void 0 : (_cycle$settings2 = cycle.settings) === null || _cycle$settings2 === void 0 ? void 0 : _cycle$settings2.individualPasscode) === true && (cycle === null || cycle === void 0 ? void 0 : cycle.type) === 'known') {
        return /*#__PURE__*/_react["default"].createElement(_UrlInfo["default"], {
          cycle: cycle
        });
      }
    });
    return _this;
  }
  _inherits(DeploySettings, _React$Component);
  return _createClass(DeploySettings, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getBulkUploadDef();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var isDifferentDeployment = this.props.cycle.deploymentId !== prevProps.cycle.deploymentId;
      var isDifferentSettings = (0, _get2["default"])(this.props, 'cycle.settings.individualPasscode', false) !== (0, _get2["default"])(prevProps, 'cycle.settings.individualPasscode', false);
      if (isDifferentDeployment || isDifferentSettings) {
        this.getBulkUploadDef();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        cycle = _this$props2.cycle,
        projectLinks = _this$props2.projectLinks;
      if (!cycle) {
        return /*#__PURE__*/_react["default"].createElement(_cccisdReactRouter.Redirect, {
          to: projectLinks.deploy
        });
      }
      var individualPasscode = cycle.settings.individualPasscode;
      if (!Fortress.hasAnyAccess(['quest.deploy', 'quest.admin'], cycle.assignment.groupId)) {
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, this.renderUrlInfo(), /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].lackPermissions
        }, /*#__PURE__*/_react["default"].createElement(_LackingPermissions["default"], {
          hideProjectDropdown: true
        })));
      }
      if (!Fortress.hasAccess('quest.view_identifiable_data', cycle.assignment.groupId)) {
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].flex
        }, this.renderUrlInfo(), /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].btngrp
        }, cycle.type === 'known' && this.renderAddRespondent(), !individualPasscode && this.renderMessaging())), /*#__PURE__*/_react["default"].createElement("div", {
          className: "alert alert-info ".concat(_style["default"].noIdPerm)
        }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_warning["default"], {
          spaceRight: true
        })), /*#__PURE__*/_react["default"].createElement("div", null, "You don't have permission to View Identifiable Data, so you can't see Quest links or respondents' identifiable data. If you need this, contact the project lead for help.")), /*#__PURE__*/_react["default"].createElement(_RespondentTable["default"], {
          omitIdentifiableColumns: true,
          cycle: cycle,
          ref: function ref(element) {
            _this2.rtConnect = element;
          }
        }));
      }
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].flex
      }, this.renderUrlInfo(), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].btngrp
      }, cycle.type === 'known' && this.renderAddRespondent(), cycle.type === 'known' && this.renderBulkAdd(), !individualPasscode && this.renderMessaging())), /*#__PURE__*/_react["default"].createElement(_RespondentTable["default"], {
        cycle: cycle,
        ref: function ref(element) {
          _this2.rtConnect = element;
        }
      }));
    }
  }]);
}(_react["default"].Component);
_defineProperty(DeploySettings, "propTypes", {
  cycle: _propTypes["default"].object,
  breadcrumbs: _propTypes["default"].array,
  project: _propTypes["default"].object,
  projectLinks: _propTypes["default"].object,
  restrictionsLevel: _propTypes["default"].string,
  // From React Router
  match: _propTypes["default"].object
});
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    cycle: (0, _admin.getDeploymentById)(state.assignment.admin, props),
    breadcrumbs: (0, _admin.getDeploymentBreadcrumbs)(state.assignment.admin, props),
    project: (0, _admin.getCurrentProject)(state.assignment.admin),
    projectLinks: (0, _admin.getProjectLinks)(state.assignment.admin),
    restrictionsLevel: (0, _admin.getRestrictionsLevel)(state.assignment.admin)
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(DeploySettings);